import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { environment } from "src/configs/constance";
import { fetchListNotification } from "src/redux/account-slice";

export default function useFetchNotify() {
  const intervalRef = useRef();
  const accountAddress = useSelector((state) => state.accountSlice.address);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchListNotify();
    intervalRef.current = setInterval(() => {
      fetchListNotify();
    }, [15000]);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [accountAddress]);

  const fetchListNotify = async () => {
    if (accountAddress && environment === "mainnet") dispatch(fetchListNotification());
  };
}
